import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2753f244&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2753f244&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=2753f244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753f244",
  null
  
)

export default component.exports